import * as yup from 'yup';
import { scopeSchema } from '../scopes/ScopeValidation';

export const sharedVoicemailSchema = yup.object().shape({
    scope: scopeSchema.required('Requis'),
    name: yup.string().required('Requis'),
    agents: yup.array().required('Requis').min(1, "Au moins un agent est requis"),
});